import type { ReactNode, HTMLAttributes } from 'react';
import styles from './MainContent.module.css';

interface MainContentProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  showFadeGradient?: boolean;
}

export const MainContent = ({
  children,
  showFadeGradient = true,
  className = '',
  ...props
}: MainContentProps) => {
  const classNames = [styles.container, className].filter(Boolean).join(' ');

  return (
    <div className={classNames} {...props}>
      {children}
      {showFadeGradient && <div className={styles.fadeGradient} />}
    </div>
  );
};


